import type { MatchedCoach } from '@/modules/api';

/**
 * How we address a coach across the coach flow: the provider's `displayName`
 * when present, otherwise a fallback of title + first name (e.g. "Coach Brian"),
 * mirroring how `providerDisplayName` itself reads. Single label — the title is
 * not shown separately.
 */
export function coachDisplayName(
  coach: Pick<MatchedCoach, 'displayName' | 'firstName' | 'title'>
): string {
  const display = coach.displayName?.trim();
  if (display) return display;
  return [coach.title, coach.firstName]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ');
}
